<template>
	<div id="app">
		<router-view />
		<modals-container />
		<p class="credits caption text-gray-6">created by michaelaangelaaustria@gmail.com © {{ currentYear }}</p>
	</div>
</template>

<script>
	export default {
		name: 'App',
		computed: {
			currentYear() {
				return new Date().getFullYear();
			},
		},
	};
</script>
